import {defineComponent} from 'vue';
import {IpproMapLayer} from '../../vl-ippro-map';

export default defineComponent({
    compatConfig: {
        MODE: 3,
    },
    name: 'IpproMapLayerToggle',
    emits: ['switch-layer'],
    props: {
        layers: {
            type: Array as () => IpproMapLayer[],
            default: () => [],
        },
    },
    setup(props, {emit}) {
        const changeLayer = (layerToggle: { $event: Event; active: string }) => {
            const layer: IpproMapLayer = props.layers.find((obj: IpproMapLayer) => obj.id === layerToggle.active);
            if (layer) {
                emit('switch-layer', layer);
            }
        }

        return {changeLayer}
    }
})
